/* eslint-disable */
export default {
  noActiveCalls: 'Geen actieve oproepen',
  currentCall: 'Huidige oproep',
  ringCall: 'Overgaande oproep',
  onHoldCall: 'Oproep staat in de wacht',
  otherDeviceCall: 'Actieve oproepen op mijn andere apparaten',
  confirmation: 'Bevestiging',
  confirmMergeToConference: 'Aan conference call toevoegen?',
  mergeToConference: 'Samenvoegen',
  conferenceCall: 'Conference call',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
